import React, { useEffect, useState } from "react";
import { Container, Row, Col, Label, FormGroup, Input } from "reactstrap";
import { ToastContainer, toast } from "react-toastify";
import { getFundByAmc } from "../../stores/services/funds.service";
import { useSelector } from "react-redux";
import Select from "react-select";
import ReactTooltip from "react-tooltip";
import { getAllActiveUnpaidDividendAnnouncementsByFund, getCorporateAnnouncementByID } from "../../stores/services/dividend-announcement.service";
import moment from "moment";
import { BsTable } from "react-icons/bs";


const DisbursementRecon = () => {

    const theme = useSelector((state: any) => state.ThemeModeReducer.Theme);
    const [allFunds, setAllFunds] = useState<any>([]);
    const [allAnnoucement, setAllAnnoucement] = useState<any>([]);
    const [annoucement, setAnnoucement] = useState("");
    const [Loading, setLoading] = useState(false);
    const [fundCheck, setFundCheck] = useState(false);
    const [fund, setFund] = useState("");
    const [accFundLoading, setAccFundLoading] = useState<any>(false);
    const [searchLoading, setSearchLoading] = useState<any>(false);
    const [annoucementLoading, setAnnoucementLoading] = useState<any>(false);
    const [allAnnouncementData, setAllAnnouncementData] = useState<any>([]);
    const email = sessionStorage.getItem("email") || "";
    const fund_code = JSON.parse(sessionStorage.getItem("fund_code") || "[]");
    const amc_code = sessionStorage.getItem("amc_code") || "";

    useEffect(() => {
        setLoading(true);
        const getFundByAMcCode = async (code: string) => {
            setAccFundLoading(true);
            allFunds.length = 0;
            setAllFunds(allFunds);

            //get funds by amc for dropdown
            try {
                const response = await getFundByAmc(
                    email,
                    code,
                    fund_code?.length > 0 ? fund_code : ""
                );
                // sort data
                let sortedData: any = [];
                sortedData = response.data.data.sort(function (a, b) {
                    let x = a.nature.toLowerCase();
                    let y = b.nature.toLowerCase();
                    if (x > y) {
                        return 1;
                    }
                    if (x < y) {
                        return -1;
                    }
                    return 0;
                });
                // setAllFunds(response.data.data);
                setAllFunds(sortedData);
                if (response.data.data.length < 1) {
                    setFundCheck(true);
                } else {
                    setFundCheck(false);
                }
                setLoading(false);

                setAccFundLoading(false);
            } catch (error) { }
        };

        getFundByAMcCode(amc_code);
    }, []);

    const getAnnoucement = async (fundVal) => {
        setLoading(true);
        try {
            setAnnoucementLoading(true)
            let res = await getAllActiveUnpaidDividendAnnouncementsByFund(
                email,
                fundVal,
                "true",
                amc_code
            )
            if (res.data.status == 200 && res?.data?.data?.length > 0) {
                setAllAnnoucement(res.data.data)
                setLoading(false);
                setAnnoucementLoading(false)
            }
            else {
                // toast.error("No Record Found for Annoucement!")
                setAllAnnoucement([])
                setLoading(false);
                setAnnoucementLoading(false)
            }
        }
        catch (error) {
            setAllAnnoucement([])
            setLoading(false);
            setAnnoucementLoading(false)
        }
    }

    const handleSearch = async () => {
        setLoading(true);
        try {
            let res = await getCorporateAnnouncementByID(
                email,
                amc_code,
                fund,
                annoucement
            )
            if (res.data.status == 200 && res.data.data?.length > 0) {
                setAllAnnouncementData(res?.data?.data)
                setLoading(false);
            }
            else {
                setAllAnnouncementData([])
                toast.error("No data found !")
                setLoading(false);
            }
        }
        catch (error) {
            setAllAnnouncementData([])
            setLoading(false);
            toast.error("No data found!")
        }
    }

    const renderFundsDropdown = () => {
        return allFunds.map((item: any, index: string) => {
            if (item.nature === "Special Managed Account") {
                return {
                    value: item.symbol_code,
                    label: `${item.fund_name} (${item.symbol_code}) - SMA`,
                };
            } else {
                return {
                    value: item.symbol_code,
                    label: `${item.fund_name} (${item.symbol_code})`,
                };
            }
        });
    };

    const renderAnnoucementDropdown = () => {
        return allAnnoucement?.map((item: any, index: string) => {
            return {
                value: item?.announcement_id,
                label: `${item.description} - ${moment(item?.from_date)?.format("DD-MMM-YYYY")} - ${moment(item?.to_date)?.format("DD-MMM-YYYY")}`,
            }
        });
    };

    const selectedFundName = React.useMemo(() => {
        const selectedFund = allFunds.find((item) => item?.symbol_code === fund);
        return selectedFund && selectedFund.nature === "Special Managed Account"
            ? {
                value: selectedFund.symbol_code,
                label: `${selectedFund.fund_name} (${selectedFund.symbol_code}) - SMA`,
            }
            : selectedFund
                ? {
                    value: selectedFund.symbol_code,
                    label: `${selectedFund.fund_name} (${selectedFund.symbol_code})`,
                }
                : null;
    }, [allFunds, fund]);

    const selectedAnnoucement = React.useMemo(() => {
        const selectedAnnoucement = allAnnoucement.find((item) => item?.announcement_id === annoucement);
        return selectedAnnoucement ? {
            value: selectedAnnoucement?.announcement_id,
            label: `${selectedAnnoucement?.description} - ${moment(selectedAnnoucement?.from_date)?.format("DD-MMM-YYYY")} - ${moment(selectedAnnoucement?.to_date)?.format("DD-MMM-YYYY")}`,
        }
            : null;
    }, [allAnnoucement, annoucement]);

    const customStyles = {
        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
        option: (styles, { isFocused, isSelected }) => ({
            ...styles,
            background: isFocused
                ? "hsla(291, 64%, 42%, 0.5)"
                : isSelected
                    ? "hsla(291, 64%, 42%, 1)"
                    : undefined,
            zIndex: 1,
        }),
        menuList: (styles) => ({
            ...styles,
            background: theme == "dark" ? "#3b3b3b" : "#ffffff",
            color: theme == "dark" ? "white" : "",
        }),
        menu: (base) => ({
            ...base,
            zIndex: 100,
        }),
        control: (base, state) => ({
            ...base,
            background: theme == "dark" ? "#25273a" : "#f2f2f2",
            borderRadius: "0.4285rem",
            borderColor: state.isFocused
                ? "#1d8cf8"
                : theme !== "light"
                    ? "#2b3553"
                    : "",
            boxShadow: state.isFocused ? null : null,
            "&:hover": {
                borderColor: state.isFocused ? "" : "#ba54f5",
            },
            '& .react-select__input input[type="color"]': {
                color: theme === "dark" ? "red" : "black",
            },
        }),
        singleValue: (provided) => ({
            ...provided,
            color: theme == "dark" ? "white" : "black",
        }),
        input: (base) => ({
            ...base,
            color: theme == "dark" ? "white" : "black",
        }),
    };

    return (
        <div className="content">
            <Row>
                <Col md="12">
                    <Container fluid>
                        <ToastContainer limit={1} />
                        <Row>
                            <Col>
                                <div className="card mb-3">
                                    <div className="card-header">
                                        <h4 className="card-title">Disbursement Recon</h4>
                                    </div>
                                    <div
                                        className="card-body">
                                        <Row>
                                            <Col
                                                md={4}
                                                sm={12}
                                                xs={12}
                                                className="form-group col-md-4"
                                                data-tip="Select Fund"
                                            >
                                                Fund Name*
                                                <ReactTooltip
                                                    textColor="white"
                                                    backgroundColor="black"
                                                    effect="float"
                                                />
                                                {accFundLoading ? (
                                                    <div className="form-control w-100">
                                                        <i className="fa fa-spinner fa-spin fa-1x"></i>
                                                    </div>
                                                ) : (
                                                    <Select
                                                        disabled={false}
                                                        value={selectedFundName}
                                                        label={fundCheck ? "No Fund Found" : "Select Fund"}
                                                        onChange={(e) => {
                                                            setAllAnnouncementData([])
                                                            setAnnoucement("")
                                                            setLoading(true);
                                                            setFund(e?.value);
                                                            setLoading(false);
                                                            getAnnoucement(e?.value)
                                                        }}
                                                        menuPortalTarget={document.body}
                                                        menuShouldBlockScroll={true}
                                                        isClearable={true}
                                                        isSearchable={true}
                                                        name="color"
                                                        options={renderFundsDropdown()}
                                                        styles={customStyles}
                                                    />
                                                )}
                                            </Col>
                                            <Col
                                                md={4}
                                                sm={12}
                                                xs={12}
                                                className="form-group col-md-4"
                                                data-tip="Select Announcement"
                                            >
                                                Announcement*
                                                <ReactTooltip
                                                    textColor="white"
                                                    backgroundColor="black"
                                                    effect="float"
                                                />
                                                {accFundLoading ? (
                                                    <div className="form-control w-100">
                                                        <i className="fa fa-spinner fa-spin fa-1x"></i>
                                                    </div>
                                                ) : (
                                                    <Select
                                                        isDisabled={!fund}
                                                        value={selectedAnnoucement}
                                                        label={fundCheck ? "No Announcement Found" : "Select Announcement"}
                                                        onChange={(e) => {
                                                            setAllAnnouncementData([])
                                                            setLoading(true);
                                                            setAnnoucement(e?.value);
                                                            setLoading(false);
                                                        }}
                                                        menuPortalTarget={document.body}
                                                        menuShouldBlockScroll={true}
                                                        isClearable={true}
                                                        isSearchable={true}
                                                        name="color"
                                                        options={renderAnnoucementDropdown()}
                                                        styles={customStyles}
                                                    />
                                                )}
                                            </Col>
                                            <Col
                                                md={4}
                                                sm={12}
                                                xs={12}
                                            >
                                                <button
                                                    style={{
                                                        marginTop: "25px"
                                                    }}
                                                    className="btn btn-primary"
                                                    disabled={Boolean(Loading)}
                                                    onClick={() => {
                                                        handleSearch()
                                                    }}
                                                >
                                                    {searchLoading ? (
                                                        <>
                                                            <span
                                                                className="spinner-border login-txt spinner-border-sm"
                                                                role="status"
                                                                aria-hidden="true"
                                                            ></span>
                                                            <span className="login-txt"> Searching...</span>
                                                        </>
                                                    ) : (
                                                        "Search"
                                                    )}
                                                </button>
                                            </Col>
                                        </Row>
                                    </div>
                                </div>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <div className="card mt-0">
                                    <div className="card-body">
                                        {!Loading ? (
                                            <>
                                                {allAnnouncementData?.length > 0 ?
                                                    <div
                                                        style={{
                                                            minHeight: "60vh"
                                                        }}
                                                        className="table-responsive">
                                                        <table
                                                            className="table " id="myTable">
                                                            <thead>
                                                                <tr>
                                                                    <th className="text-nowrap">Folio #</th>
                                                                    <th>Name</th>
                                                                    <th className="text-nowrap">CNIC</th>
                                                                    <th>TaxStatus</th>
                                                                    <th>ZakatStatus</th>
                                                                    <th>NAV</th>
                                                                    <th>PerUnitValue</th>
                                                                    <th>Holding</th>
                                                                    <th>GrossDividend</th>
                                                                    <th>TaxableDividend</th>
                                                                    <th>TaxableRate</th>
                                                                    <th>RefundOfCapital</th>
                                                                    <th>RefundOfCapitalUnits</th>
                                                                    <th>NonTaxableRate</th>
                                                                    <th>TaxAmount</th>
                                                                    <th>EnCashAmount</th>
                                                                    <th>ReInvestAmount</th>
                                                                    <th>EnCashUnits</th>
                                                                    <th>ReInvestUnits</th>
                                                                    <th>AccountCode</th>
                                                                    <th>AccountTitle</th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                {allAnnouncementData?.map((item, index) => {
                                                                    return (
                                                                        <tr key={index}>
                                                                            <td className="text-nowrap">{item?._doc?.folio_no}</td>
                                                                            <td style={{ minWidth: "150px" }}>{item?._doc?.name}</td>
                                                                            <td className="text-nowrap">{item?._doc?.cnic}</td>
                                                                            <td>{item?._doc?.tax_status}</td>
                                                                            <td>{item?._doc?.zakat_exempt}</td>
                                                                            <td></td>
                                                                            <td></td>
                                                                            <td></td>
                                                                            <td></td>
                                                                            <td>{item?._doc?.gross_dividend}</td>
                                                                            <td></td>
                                                                            <td></td>
                                                                            <td></td>
                                                                            <td></td>
                                                                            <td></td>
                                                                            <td></td>
                                                                            <td></td>
                                                                            <td></td>
                                                                            <td></td>
                                                                            <td>{item?._doc?.account_no}</td>
                                                                            <td style={{ minWidth: "150px" }}>{item?._doc?.account_title}</td>
                                                                        </tr>
                                                                    )
                                                                })}
                                                                <tr></tr>
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                    :
                                                    <div className="table-empty">
                                                        <BsTable className="icon" />
                                                        <p className="text-center empty-text">Empty</p>
                                                    </div>
                                                }
                                            </>
                                        ) : (
                                            <div className="d-flex justify-content-center my-4">
                                                <i className="fa fa-spinner fa-spin fa-3x"></i>
                                            </div>
                                        )}

                                    </div>
                                </div>
                            </Col>
                        </Row>
                    </Container>
                </Col>
            </Row>
        </div>
    );
};

export default DisbursementRecon;
